"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = exports.StyledPill = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Pill_types_1 = require("./Pill.types");
exports.StyledPill = styled_components_1.default.div `
  font-family: ${({ fontFamily }) => `${fontFamily}`};
  font-size: ${({ fontSize }) => `${fontSize}`};
  font-weight: bold;
  background-color: ${({ color, theme }) => {
    if (color === Pill_types_1.PillColor.Primary) {
        return theme.colors.theme.themePrimary.value;
    }
    if (color === Pill_types_1.PillColor.Secondary) {
        return theme.colors.theme.themeSecondary.value;
    }
    if (color === Pill_types_1.PillColor.Archive) {
        return theme.colors.colours.support[40].value;
    }
    return theme.colors.colours.system[color].value;
}};
  color: ${({ textColor }) => textColor};
  display: inline-flex;
  align-items: center;
  height: ${({ size }) => `${size}`};
  transition: background-color 0.25s ease-in-out;
  border-radius: ${({ size }) => `${size}`};

  .pill {
    &__icon {
      ${({ pillSize, hasText }) => {
    if (pillSize === Pill_types_1.PillSize.ExtraSmall || pillSize === Pill_types_1.PillSize.Small) {
        return (0, styled_components_1.css) `
            margin-right: ${({ theme }) => hasText && theme.sizes['5xs'].value};
          `;
    }
    return (0, styled_components_1.css) `
          margin-right: ${({ theme }) => hasText && theme.sizes['4xs'].value};
        `;
}}

      height: ${({ iconSize }) => iconSize};
      width: ${({ iconSize }) => iconSize};
    }
  }

  ${({ size, hasText, padding, pillSize, theme }) => {
    if (!hasText) {
        return (0, styled_components_1.css) `
        padding: ${theme.sizes['5xs'].value};
        width: ${size};
        display: flex;
        align-items: center;
        justify-content: center;
      `;
    }
    if (pillSize === Pill_types_1.PillSize.ExtraSmall) {
        return (0, styled_components_1.css) `
        padding: 0 ${padding} 0 ${theme.sizes['4xs'].value};
      `;
    }
    if (pillSize === Pill_types_1.PillSize.Small) {
        return (0, styled_components_1.css) `
        padding: 0 ${padding} 0 ${theme.sizes['2xs'].value};
      `;
    }
    return (0, styled_components_1.css) `
      padding: 0 ${padding} 0 ${theme.sizes.xs.value};
    `;
}}
`;
exports.StyledText = styled_components_1.default.div `
  margin-left: ${({ hasText, marginText }) => hasText && marginText};
`;
//# sourceMappingURL=Pill.styled.js.map